import { encrypt } from "../utils/crypt";

function escapeBadChars(encryptedStr) {
    if (!encryptedStr) return encryptedStr;
    
    // Escape ALL non-alphanumeric characters except safe ones
    // Only allow: letters (a-z, A-Z), numbers (0-9), and safe chars (. _ -)
    return encryptedStr.replace(/[^a-zA-Z0-9._-]/g, match => {
        return `&#${match.charCodeAt(0)};`;
    });
}

async function deleteService(user, title) {
    const url = "https://deploy.vectorvault.io/delete_service"
    const payload = {
        USER: escapeBadChars(encrypt(user)),
        TITLE: title
    };

    try {
        const token = localStorage.getItem('vectorVaultAccessToken');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error('Server responded with an error: ' + errorText);
        }
    
        const responseData = await response.json();
        console.log(response);
        return responseData;
    } catch (error) {
        console.error("Error in DELETE request:", error);
        throw error; // Re-throw the error so it can be handled by the caller
    }
}

export default deleteService;